import { observable } from "mobx";

import {
  apiPutPatientsPatientId,
  Level3MinimalPatientResponse,
  MinimalPatientResponse,
  PatientBaseSchema,
  PermissionBit,
} from "../../api";
import { location } from "../../app/location";
import { hasPermission } from "../../constants/permissions";
import { DataModel } from "../../models/data-model";
import {
  canApprovePaperConsent,
  canRevokePaperConsent,
  consentOk,
} from "../../utils/data-utils";
import { Merge } from "../../utils/types";

export class Patients extends DataModel<PatientsItem> {
  readonly idAttr = "patient_id";
  @observable accessor loading = false;

  constructor(
    data: PatientsItem[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);
  }

  async updatePatient(patId: number, field: object) {
    await apiPutPatientsPatientId({
      path: { patient_id: patId },
      body: field,
    });
    location.reload();
  }

  canApprovePaperConsent(patient: PatientBaseSchema) {
    return canApprovePaperConsent(patient);
  }

  canRevokePaperConsent(patient: PatientBaseSchema) {
    return canRevokePaperConsent(patient);
  }

  consentOk(patient: PatientsItem) {
    return consentOk(patient);
  }

  disabledPatLink(patient: PatientsItem) {
    return (
      !this.consentOk(patient) &&
      !hasPermission(this.permissions ?? [], PermissionBit.BYPASS_CONSENT)
    );
  }
}

export type PatientsItem = Merge<
  Level3MinimalPatientResponse | MinimalPatientResponse
>;
